/* eslint-disable @typescript-eslint/no-explicit-any */
import Loader from "@/src/components/Loader";
import Address from "./components/Address";
import Name from "./components/Name";
import ProfileImage from "./components/ProfileImage";
import { useFirstPaint } from "@/src/hooks/useFirstPaint";

const Profile = () => {
  const { firstPaint, isLoading } = useFirstPaint();
  if (isLoading) return <Loader />;
  return (
    <div className="grid gap-5">
      <ProfileImage profile={firstPaint?.profile} />
      <Name profile={firstPaint?.profile} />
      <Address profile={firstPaint?.profile} />
    </div>
  );
};

export default Profile;
